export const NOTE_LIST_REQUEST = 'NOTE_LIST_REQUEST';
export const NOTE_LIST_REQUEST_SUCCESS = 'NOTE_LIST_REQUEST_SUCCESS';
export const NOTE_LIST_REQUEST_ERROR = 'NOTE_LIST_REQUEST_ERROR';

export const NOTE_ADD = 'NOTE_ADD';
export const NOTE_ADD_SUCCESS = 'NOTE_ADD_SUCCESS';
export const NOTE_ADD_ERROR = 'NOTE_ADD_ERROR';
